import { render, staticRenderFns } from "./indexWeddingringsByColor.vue?vue&type=template&id=2efd1a1c"
import script from "./indexWeddingringsByColor.vue?vue&type=script&lang=ts"
export * from "./indexWeddingringsByColor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ElementSnapSlider: require('/codebuild/output/src1993466134/src/acredo-website/components/element/elementSnapSlider.vue').default})
